module.exports = __webpack_public_path__ + "static/media/group-survey-title2.fa0f3bd3.jpg";